module.exports = __webpack_public_path__ + "img/logoAR_transparency.259dafdc.png";